module.exports = __webpack_public_path__ + "static/careDemo4-1a6079d15f371171123967f5a65831e8.svg";